var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 34.875H18.75C17.0241 34.875 15.625 36.2741 15.625 38V81.75C15.625 83.4759 17.0241 84.875 18.75 84.875H81.25C82.9759 84.875 84.375 83.4759 84.375 81.75V38C84.375 36.2741 82.9759 34.875 81.25 34.875Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9375 34.875V20.8125C35.9375 17.0829 37.4191 13.506 40.0563 10.8688C42.6935 8.23158 46.2704 6.75 50 6.75C53.7296 6.75 57.3065 8.23158 59.9437 10.8688C62.5809 13.506 64.0625 17.0829 64.0625 20.8125",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 64.5625C52.5888 64.5625 54.6875 62.4638 54.6875 59.875C54.6875 57.2862 52.5888 55.1875 50 55.1875C47.4112 55.1875 45.3125 57.2862 45.3125 59.875C45.3125 62.4638 47.4112 64.5625 50 64.5625Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/LockOpen.2e0f010b972b8abe88b0ba211401ed08.svg";
export { ForwardRef as ReactComponent };